import * as React from "react";
//import RegisterCompleteProps from '../../interfaces/RegisterCompleteProps';

//let authStyle = require('../../styles/auth.styl');

export default class RegisterComplete extends React.Component {
    render() {
        return (
            <div className="col-sm-6 offset-sm-3 alert alert-success" role="alert">
                <strong>Wir haben eine Email an Sie gesendet.</strong>  
            </div>
        )
    }
}